// extracted by mini-css-extract-plugin
export var darkMode = "_redotech-redo-web-lib-theme-component-colors-dark-dark-mode";